// extracted by mini-css-extract-plugin
export default {"main":"app_main__Mk+bc","footer":"app_footer__4j-b+","grid":"app_grid__sNCZf","col_1":"app_col_1__uzF+x","col_2":"app_col_2__p5Nqa"};